import { render, staticRenderFns } from "./CRAbouttheData.vue?vue&type=template&id=eacdc152"
import script from "./CRAbouttheData.vue?vue&type=script&lang=js"
export * from "./CRAbouttheData.vue?vue&type=script&lang=js"
import style0 from "./CRAbouttheData.vue?vue&type=style&index=0&id=eacdc152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports